export const DceKey = {
  PRODUCT_ID: 'productId',
  UNIT_SOLD_TF: 'unitSold',
  LIFE_TIME: 'lifeTime',
  FUEL_TYPE: 'fuelType',
  FUEL_USED: 'fuelUsed',
  REFRIGERATOR_TYPE: 'refrigerantType',
  REFRIGERATOR_USED: 'refrigerantUsed',
  ELEC_CONSUME: 'electricityConsumption'
};

export const DceLabel = {
  PRODUCT_ID: 'Product / Service Name',
  UNIT_SOLD_TF: 'Unit Sold',
  LIFE_TIME: 'Total Life Time',
  FUEL_TYPE: 'Fuel',
  FUEL_USED: 'Quantity',
  REFRIGERATOR_TYPE: 'Refrigerant and suppressant',
  REFRIGERATOR_USED: 'Quantity',
  ELEC_CONSUME: 'Electricity Consumption'
};
